import { useEffect } from 'react'
import { Box } from '@mui/material'
import { Card, StatusIndicator } from 'packages/eid-ui'
import { usePageContext } from 'pageContext'
import { useTranslation } from 'react-i18next'
import GenericFilter from '../EidFilter/GenericFilter'
import { useLandscapes } from 'hooks'

const LandscapesFilter = ({ trackingID }) => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()
    const { data: landscapesData } = useLandscapes(trackingID)

    // Set default selection to Active landscapes
    useEffect(() => {
        if (landscapesData && !state.landscapes?.length) {
            const activeLandscapes = landscapesData
                .filter((l) => l.rtA_CSVInboxLandscapeStatusName === 'Active')
                .map((l) => ({
                    id: l.rtA_LandscapeID,
                    name: l.landscapeName,
                    friendlyName: l.landscapeFriendlyName,
                    status: l.rtA_CSVInboxLandscapeStatusName,
                }))

            if (activeLandscapes.length > 0) {
                dispatch({
                    type: 'SET_PROP',
                    payload: {
                        key: 'landscapes',
                        value: activeLandscapes,
                    },
                })
            }
            else {
                dispatch({
                    type: 'SET_PROP',
                    payload: {
                        key: 'landscapes',
                        value: null,
                    },
                })
            }
        }
    }, [landscapesData, dispatch, state.landscape])

    const renderStatusIndicator = (item) => {
        const statusLabels = {
            Active: t('Active'),
            NotStarted: t('NotStarted'),
        }
        return (
            <StatusIndicator
                variant={item.status}
                label={statusLabels[item.status] || item.status}
                size="small"
            />
        )
    }

    return (
        <Card
            cardTitle={t('Landscapes')}
            collapsible
            expanded={Boolean(state.landscapes)}
        >
            <Box
                padding="0"
                style={{
                    borderTop: 'solid 1px #efeff1',
                    backgroundColor: '#fbfbfd',
                }}
            >
                <Box padding="20px 20px 0px 20px">
                    <GenericFilter
                        type="checklist"
                        searchable={false}
                        searchPlaceholder={null}
                        staticData={landscapesData?.map(landscape => ({
                            id: landscape.rtA_LandscapeID,
                            name: landscape.landscapeName,
                            friendlyName: landscape.landscapeFriendlyName,
                            status: landscape.rtA_CSVInboxLandscapeStatusName,
                            disabled: landscape.rtA_CSVInboxLandscapeStatusName === 'Not Promoted'
                        }))}
                        dedupingInterval="1800000"
                        debounceInterval="500"
                        contextProp="landscapes"
                        selectedValueIndicatorProp="id"
                        state={state}
                        showPagination={false}
                        renderItemSuffix={renderStatusIndicator}

                    />
                </Box>
            </Box>
        </Card>
    )
}

export default LandscapesFilter
